export const TaskValidationSchema = (json, isEditMode = false) => {
    return new Promise((resolve) => {
        const errorJson = {};

        // Basic Information Validation
        if (!json?.taskName || json.taskName.trim() === '') {
            errorJson.taskName = "Task name is required *";
        }

        if (!json?.description || json.description.trim() === '') {
            errorJson.description = "Task description is required *";
        }

        if (!json?.priority || json.priority === '') {
            errorJson.priority = "Priority level is required *";
        }

        // Task Frequency Validation
        if (!json?.taskFrequency || json.taskFrequency === '') {
            errorJson.taskFrequency = "Task frequency is required *";
        }


        // Schedule-specific validations based on frequency
        if (json?.taskFrequency) {
            switch (json.taskFrequency) {
                case 'once':
                    // For 'once' frequency, validate start and end date/time
                    if (!json?.startDateTime) {
                        errorJson.startDateTime = "Start date & time is required *";
                    }
                    if (!json?.endDateTime) {
                        errorJson.endDateTime = "End date & time is required *";
                    }
                    // Validate that end time is after start time
                    if (json?.startDateTime && json?.endDateTime) {
                        const startTime = new Date(json.startDateTime).getTime();
                        const endTime = new Date(json.endDateTime).getTime();
                        if (endTime <= startTime) {
                            errorJson.endDateTime = "End time must be after start time *";
                        }
                    }
                    break;

                case 'daily':
                    if (!json?.taskIntervals || !Array.isArray(json.taskIntervals) || json.taskIntervals.length === 0) {
                        errorJson.taskIntervals = "At least one time interval is required *";
                    }
                    break;

                case 'weekly':
                    // if (!json?.weekDays || !Array.isArray(json.weekDays) || json.weekDays.length === 0) {
                    //     errorJson.weekDays = "At least one day of the week is required *";
                    // }
                    if (!json?.taskIntervals || !Array.isArray(json.taskIntervals) || json.taskIntervals.length === 0) {
                        errorJson.taskIntervals = "At least one time interval is required *";
                    }
                    break;

                case 'monthly':
                    if (!json?.monthWeeks || !Array.isArray(json.monthWeeks) || json.monthWeeks.length === 0) {
                        errorJson.monthWeeks = "At least one week of the month is required *";
                    }
                    if (!json?.weekDaysForMonthly || !Array.isArray(json.weekDaysForMonthly) || json.weekDaysForMonthly.length === 0) {
                        errorJson.weekDaysForMonthly = "At least one day is required *";
                    }
                    if (!json?.taskIntervals || !Array.isArray(json.taskIntervals) || json.taskIntervals.length === 0) {
                        errorJson.taskIntervals = "At least one time interval is required *";
                    }
                    break;

                default:
                    errorJson.taskFrequency = "Invalid task frequency selected *";
            }
        }

        // Assignment Validation
        if (!json?.roleId || json.roleId === '') {
            errorJson.roleId = "Role selection is required *";
        }

        // assignedTo is optional - users can be assigned to a role without specific user assignment
        // No validation needed for assignedTo as it's optional

        // Additional validations
        if (json?.scheduledDateTime) {
            const selectedDate = new Date(json.scheduledDateTime);
            const today = new Date();
            
            if (selectedDate < today) {
                errorJson.scheduledDateTime = "Scheduled date & time cannot be in the past *";
            }
        }

        // Validate start/end times for 'once' frequency
        if (json?.startDateTime) {
            const startDate = new Date(json.startDateTime);
            const today = new Date();
            
            if (startDate < today) {
                errorJson.startDateTime = "Start date & time cannot be in the past *";
            }
        }

        // Validate task name length
        if (json?.taskName && json.taskName.length > 100) {
            errorJson.taskName = "Task name cannot exceed 100 characters *";
        }

        // Validate description length
        if (json?.description && json.description.length > 500) {
            errorJson.description = "Description cannot exceed 500 characters *";
        }

        resolve(errorJson);
    });
};